import Button from '../Button/Button';
import { Dialog, DialogContent } from '../Dialog/Dialog';
import IconButton from '../IconButton/IconButton';
import styles from './Confirm.module.scss';

type Props = {
  open: boolean;
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
};

const Confirm: React.FC<Props> = ({
  open,
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) => {
  return (
    <Dialog open={open} data-testid="confirm-dialog">
      <DialogContent className={styles['root']}>
        <div className={styles['close-container']}>
          <IconButton icon="close-x" size={16} action={onCancel} />
        </div>
        <h2>{title}</h2>
        <p>{description}</p>
        <div className={styles['footer']}>
          <Button
            text={cancelText}
            color="secondary-black"
            border
            disabled={false}
            action={onCancel}
            type="button"
            data-testid="close-button"
          />
          <Button
            text={confirmText}
            color="primary-black"
            disabled={false}
            action={onConfirm}
            type="button"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Confirm;
